import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.sgp-animal-tree-select-node-text {
  color: ${dt('surface.900')};
  white-space: normal;
  word-break: break-word;
  display: block;
}
`;
